import { CookieStorage } from "@/tools/cookie.js";
import { getCookieDomain, getDomain } from "@/tools/location.js";

export const mainStorage = new CookieStorage(
  8,
  getCookieDomain(getDomain(window.location.hostname, 2)),
);